$(document).ready(function() {
  $('.styled-range').each(function() {
    $container = $(this).find('.styled-range--input');
    $container.append('<div class="styled-range--input-track"></div>');
    $input = $container.find('input');
    $track = $container.find('.styled-range--input-track');
    var thumb_width = 20 / 2;
    var tick_width = 4;
    var min = parseFloat($input.attr('min'));
    var correction = 0;
    var max = parseFloat($input.attr('max')) - correction;
    var step = parseFloat($input.attr('step'));
    if (min >= 0 && max >= 0 && max > min && step > 0) {
      // make sure the range is from 0 to X
      if (min > 0) {
        correction = 0 - min;
        min = 0;
        max += correction;
      }

      // add the track ticks
      for(i = min; i <= max; i += step) {
        var percentage = 0;
        if (i >= max) {
          percentage = 100;
        } else if (i > min){
          percentage = (i / (max / 100));
        }

        var tick_correction = ((percentage / 100) * 4);
        var left = 'calc(' + percentage + '% - ' + tick_correction + 'px)';
        $track.append('<span class="tick" style="left: ' + left + '"></span>');
      }
    }
  });
});